// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"5656539d","483":"7aebd2ad","488":"98fefb5f","726":"39c7cf2a","952":"d89829e8"}[chunkId] + ".chunk.js";
};